import { Box, Button, FormControl, FormErrorMessage, Input, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import { isValidEmail } from '@common/utility/validations';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

type JoinFormProps = {
  form: UseFormReturn<{ email: string }, any>;
  isLoading: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
};

export const JoinForm: React.FC<JoinFormProps> = ({ form, isLoading, onSubmit }) => {
  return (
    <Box as="form" width="full" onSubmit={onSubmit} py={'40px'}>
      <VStack>
        <FormControl isInvalid={Boolean(form.formState.errors.email)} mb={'5px'}>
          <Box
            p="2px"
            display="inline-block"
            background={'linear-gradient(180deg, #0B7AFF 0%, rgba(48, 142, 255, 0.26) 100%);'}
            borderRadius={'8px'}
            borderColor={'white'}
            w={'full'}>
            <Input
              id="email"
              placeholder="Email Address"
              {...form.register('email', {
                required: 'Please enter an email',
                validate: (v) => isValidEmail(v) || 'Please use a valid email address',
              })}
              autoFocus={true}
              w="full"
              p={7}
              display="block"
              bg={'white'}
            />
          </Box>

          <FormErrorMessage>{form.formState.errors.email?.message}</FormErrorMessage>
        </FormControl>
        <Button
          isDisabled={Boolean(form.formState.errors.email) || isLoading}
          isLoading={isLoading}
          type="submit"
          w={'100%'}
          rightIcon={<Icon icon="arrow-right-long" boxSize={'20px'} />}
          p={7}
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          fontWeight={'normal'}>
          Request invitation
        </Button>
      </VStack>
    </Box>
  );
};
